import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

/* Configuración conexion api */
const config = {
  // Endpoints
  // loginEndpoint: 'http://127.0.0.1:3000/api/auth/login',
  loginEndpoint: 'https://back.blumbit.net/api/auth/login',
  // registerEndpoint: '/api/register',
  // refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/api/auth/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'access_token',
  storageRefreshTokenKeyName: 'refreshToken',
}

// const { jwt } = useJwt(axios, {})
const { jwt } = useJwt(axios, config)
export default jwt
